import { render, staticRenderFns } from "./paba-two-factor.vue?vue&type=template&id=ae3e6992&scoped=true&lang=pug"
import script from "./paba-two-factor.vue?vue&type=script&lang=js"
export * from "./paba-two-factor.vue?vue&type=script&lang=js"
import style0 from "./paba-two-factor.vue?vue&type=style&index=0&id=ae3e6992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3e6992",
  null
  
)

export default component.exports